import { render, staticRenderFns } from "./MdMiddle.vue?vue&type=template&id=6fb13470&scoped=true&"
import script from "./MdMiddle.vue?vue&type=script&lang=js&"
export * from "./MdMiddle.vue?vue&type=script&lang=js&"
import style0 from "./MdMiddle.vue?vue&type=style&index=0&id=6fb13470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb13470",
  null
  
)

export default component.exports